import {useContext, useEffect, useState} from 'react'
import {Col, Row, Stack} from 'react-bootstrap'
import {generateExcel, generateSimplifiedExcel} from '../../../../services/fichas'
import {getProceso} from '../../../../services/procesos'
import {TableSearch} from '../../../../shared/TableSearch'
import {DataUser} from '../../../documentacion/MiFicha/DataUserInterface'
import {PartnerContext} from '../BandejaProcesoContexts'

const PartnersListHeader = () => {
  const buttonsData = [
    {
      iconName: 'time',
      title: 'PENDIENTE',
      stateName: 'pendientePorColaborador',
      color: '#3498db', // Blue
      abbr: 'F',
    },
    {
      iconName: 'check-square',
      title: 'COMPLETADO',
      stateName: 'completadoPorColaborador',
      color: '#9b59b6', // Purple
      abbr: 'F',
    },
    {
      iconName: 'verify',
      title: 'APROBADO CON PENDIENTE',
      stateName: 'aprobadoConPendiente',
      color: '#f39c12', // Orange
      abbr: 'F',
    },
    {
      iconName: 'security-user',
      title: 'APROBADO',
      stateName: 'aprobadoPorAdmin',
      color: '#2ecc71', // Green
      abbr: 'F',
    },
    {
      iconName: 'security-user',
      title: 'HISTORICO',
      stateName: 'historico',
      color: '#2ecccc', // Green
      abbr: 'F',
    },
    {
      iconName: 'notepad-edit',
      title: 'EN PROCESO',
      stateName: 'fichaSiendoEditada',
      color: '#000000', // Purple
      abbr: 'F',
    },
    {
      iconName: 'exclamation-triangle', // Adjust the icon name
      title: 'ANULADO',
      stateName: 'procesoAnulado',
      color: '#e74c3c', // Red
      abbr: 'P',
    },
    {
      iconName: 'eye',
      title: 'OBSERVADO',
      stateName: 'fichaObservada',
      color: '#d35400',
      abbr: 'F',
    },
    {
      iconName: 'exclamation-triangle',
      title: 'CERRADO',
      stateName: 'procesoCerrado',
      color: '#8A2BE2  ',
      abbr: 'P',
    },
    {
      iconName: 'exclamation-triangle',
      title: 'CERRADO CON PENDIENTES',
      stateName: 'procesoCerradoConPendiente',
      color: '#B22222',
      abbr: 'P',
    },
    {
      iconName: 'exclamation-triangle',
      title: 'PENDIENTES DE FIRMA',
      stateName: 'documentosPendientesDeFirma',
      color: '#cd27bf',
      abbr: 'D',
    },
    {
      iconName: 'exclamation-triangle',
      title: 'EN PROCESO DE FIRMA',
      stateName: 'documentosEnProcesoDeFirma',
      color: '#f56335',
      abbr: 'D',
    },
    {
      iconName: 'exclamation-triangle',
      title: 'FIRMADOS',
      stateName: 'documentosFirmados',
      color: '#A56331',
      abbr: 'D',
    },
  ]

  const [activeButtons, setActiveButtons] = useState(buttonsData.map(() => false))
  const [processData, setProcessData] = useState([])
  const [idproceso, setIdproceso] = useState('')
  const usuarioJSON = localStorage.getItem('userData')
  let usuario: DataUser | null = null

  if (usuarioJSON !== null) {
    usuario = JSON.parse(usuarioJSON)
  }

  const {
    setActiveOnly,
    setState,
    setSearchTerm,
    setSheetId,
    setEntryDateFrom,
    setEntryDateTo,
    openFichaPlantillaModal,
    setShowCargaExcelModal,
  } = useContext(PartnerContext)

  useEffect(() => {
    const options = {
      responsables: usuario?.userId,
    }
    getProceso(1, 100, options).then((response) => {
      if (response.success) {
        // setIdproceso(response.data[0]._id)
        setProcessData(response.data.map((x: any) => ({label: x.nombre, value: x._id})))
      } else {
        console.log(response.msg)
      }
    })
  }, [])

  const handleSearch = (value: string) => {
    setSearchTerm(value)
  }

  const handleInputChange = (event: any) => {
    setIdproceso(event.target.value)
  }

  const handleButtonClick = (index: number) => {
    const newActiveButtons = [...activeButtons]
    newActiveButtons[index] = !newActiveButtons[index]
    setActiveButtons(newActiveButtons)
    setState(
      buttonsData
        .map((x, i) => (newActiveButtons[i] ? x.stateName : ''))
        .filter((n) => n.length > 0)
    )
  }

  const handleChange = (e: any) => {
    // setFormData({...formData, [e.target.name]: e.target.value})
    setActiveOnly(e.target.value)
  }

  const handleStateChange = (e: any) => {
    setState(e.target.value)
  }

  const handleClearFilters = () => {
    // setActiveOnly(true)
    // setState([''])
    // setSearchTerm('')
    // setEntryDateFrom(null)
    // setEntryDateTo(null)
  }

  const handleExport = (id: any) => {
    generateExcel()
      .then((response) => console.log(response))
      .catch((error) => console.log(error))
  }

  const handleSimplifiedExport = (id: any) => {
    generateSimplifiedExcel()
      .then((response) => console.log(response))
      .catch((error) => console.log(error))
  }

  const handleShowFicha = () => {
    setSheetId('647c0e1f0b0325fc1a8215f5')
    openFichaPlantillaModal()
  }
  const handleShowCargaExcel = () => {
    setSheetId('647c0e1f0b0325fc1a8215f5')
    setShowCargaExcelModal(true)
  }

  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row className='mb-4'>
          <Col>
            <div className='d-flex gap-2'>
              <span>Leyenda:</span>
              <span>
                <strong>D</strong>: Documentos /
              </span>
              <span>
                <strong>F</strong>: Ficha /
              </span>
              <span>
                <strong>P</strong>: Proceso
              </span>
            </div>
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            <Stack>
              <span className='fw-bold'>Buscar Proceso</span>
              <TableSearch className='same-height' onSearch={handleSearch} design={true} />
            </Stack>
          </Col>
        </Row>
      </div>
    </>
  )
}

export {PartnersListHeader}
